const Introduction = () => (
  <div className="container">
    <span>Hello I&apos;m</span>
    <h1>Luis Octavio Ramirez Cruz</h1>
    <span>I am a full-stack software developer.</span>
    <span>I can help you build a product, feature or website</span>
    <span>Look through some of my work.</span>
    <span>Here you can see some projects I have built using several technologies.</span>
    <span>If you are interested in someone to work on a coding project, </span>
    <span>doesn&apos;t hesitate to contact me</span>
    <div className="contact-links">
      <span>See my works</span>
      <div className="separation-line" />
      <div className="contact-icons">
        <a href="https://github.com/LOctavio">
          <img alt="github" src="https://img.icons8.com/material-sharp/50/000000/github.png" />
        </a>
        <a href="https://www.linkedin.com/in/luis-octavio-ramirez-cruz/">
          <img alt="linkedin" src="https://img.icons8.com/material-sharp/50/000000/linkedin--v1.png" />
        </a>
        <a href="https://twitter.com/Octavio_ram431">
          <img alt="twitter" src="https://img.icons8.com/ios-glyphs/50/000000/twitter--v1.png" />
        </a>
        <a href="https://medium.com/@luis_ram1997">
          <img alt="medium" src="https://img.icons8.com/ios-filled/50/000000/medium-new.png" />
        </a>
      </div>
    </div>
  </div>
);

export default Introduction;
